import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import SETTINGS from '../../settings';
import mapTheme from '../../styles/mapTheme';

class GoogleMap extends Component {
  static defaultProps = {
    center: {
      lat: 40.015,
      lng: -105.27,
    },
    zoom: 13,
  };

  componentDidMount() {
    console.log(this.props.children);
  }

  render() {
    let defaultApiLoad = ({ map, maps }) => null;
    let urlKeys = this.props.bootstrapURLKeys
      ? this.props.bootstrapURLKeys
      : { key: SETTINGS.googleMapsApiKey };

    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '100vh', width: '100%' }} id="google-print">
        <GoogleMapReact
          bootstrapURLKeys={urlKeys}
          center={this.props.center}
          zoom={this.props.zoom}
          onGoogleApiLoaded={
            this.props.onGoogleApiLoaded ? this.props.onGoogleApiLoaded : defaultApiLoad
          }
          yesIWantToUseGoogleMapApiInternals
          options={{
            styles: mapTheme,
            zoomControl: this.props.zoomControl !== undefined ? this.props.zoomControl : true,
            zoomControlOptions: {
              position: 6, //LEFT BOTTOM. CORRESPONDS TO THE INTEGERS IN MAPS API (maps object from onGoogleApiLoaded). Found in maps.ControlPosition object.
            },
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
          }} //handy tool to change styling: https://mapstyle.withgoogle.com/
        >
          {this.props.children}
        </GoogleMapReact>
      </div>
    );
  }
}

export default GoogleMap;
